import React from 'react'

const Erros = () => {
  return (
    <div>Erros</div>
  )
}

export default Erros